import styled from "styled-components";

import { Text } from "@similarweb/ui-components/foundations";

export const StyledTruncatedText = styled(Text)<{ $height: number }>`
    max-height: ${({ $height }) => $height}px;
    overflow: hidden;
`;

export const StyledTruncatedTextIcon = styled.span`
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 4px;
`;
